import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App.jsx';
import store from './store';
import './index.css';

const rootElement = document.getElementById('root');

const app = (
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// Public marketing/legal routes are prerendered to static HTML at build time
// (scripts/prerender.mjs) so crawlers — e.g. Google's OAuth verification bot —
// see real content instead of an empty SPA shell. Keep this list in sync with
// PRERENDER_ROUTES in that script.
const PRERENDERED_ROUTES = new Set([
  '/', '/privacy', '/terms', '/about', '/how-it-works',
  '/pricing', '/contact', '/help', '/cookies',
]);

// Hydrate only when the current path was actually prerendered (its markup matches).
// For every other route the server fell back to the prerendered home markup in
// index.html, so clear it and client-render fresh to avoid a hydration mismatch.
if (rootElement.hasChildNodes() && PRERENDERED_ROUTES.has(window.location.pathname)) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  rootElement.innerHTML = '';
  ReactDOM.createRoot(rootElement).render(app);
}
